// 导入组件
import Vue from "vue";
import Router from "vue-router";

import Staging from "@/views/staging";
import MobileStaging from "@/views/mobileStaging";

// 启用路由
Vue.use(Router);

// 导出路由
export default new Router({
  mode: "history",
  routes: [
    {
      path: "/tron_pc",
      name: "",
      component: Staging,
      hidden: true,
      meta: {
        requireAuth: false,
      },
    },
    {
      path: "/tron_m",
      name: "",
      component: MobileStaging,
      hidden: true,
      meta: {
        requireAuth: false,
      },
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js